var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pos-documents',{attrs:{"configurl":'/api/budgets/create'}})
}
var staticRenderFns = []

export { render, staticRenderFns }